export const ruleFieldTypes = [
  { label: 'Soma', value: 'sum' },
  { label: 'Mínimo', value: 'minimum' }
];
